export default __webpack_public_path__ + "static/media/GH1.453f4b2d.png";